import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {SalesPortalService} from 'src/app/services/sales-portal.service';

@Component({
  selector: 'workshop-acquisition-detail',
  templateUrl: './workshop-acquisition-detail.component.html',
  styleUrls: ['./workshop-acquisition-detail.component.less'],
})
export class WorkshopAcquisitionDetailComponent implements OnInit {
  isSpinning: boolean = false;
  detailInfo: any = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public salesPortalService: SalesPortalService
  ) {
  }

  ngOnInit(): void {
    document.body.classList.add('sales-portal-body');

    this.route.queryParams.subscribe((params) => {
      const query = {
        targetYear: params['targetYear'],
        dealerCode: params['dealerCode'],
        dealerOrgCode: params['dealerOrgCode'],
        dealerChannelCode: params['dealerChannelCode'],
      };
      this.getDetail(query);

      this.salesPortalService.dealerTargetSummary({
        targetYear: query.targetYear,
        dealerCode: query.dealerCode,
        dealerOrgCode: query.dealerOrgCode,
        dealerChannelCode: query.dealerChannelCode,
      });
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('sales-portal-body');
  }

  navigate(path: string): void {
    this.router.navigate([path]);
  }

  getDetail(params: object) {
    this.isSpinning = true;
    this.salesPortalService.customerTargetSplitDetail(params).subscribe(
      (result: any) => {
        const {rtnCode, rtnData} = result;
        if (rtnCode === 10000) {
          this.detailInfo = rtnData;
        }
        this.isSpinning = false;
      },
      () => {
        this.isSpinning = false;
      }
    );
  }
}
